/**
 * Library version.
 * @type {string}
 */
const version = "__OTPAUTH_VERSION__";

export { version };
